import River from './River';
import texts from './data.js';

const RiverCanvas = () => {
    return (
      <div style={{
        width: '100%',
        height: '100%',
      }}>
        <River
          waveCount={10}
          waveColors={['blue']}
          waveSpeeds={[0.001, 0.002, 0.003, 0.004, 0.005, 0.006, 0.007, 0.008 ]}
          documentBackgroundColor='pink'
          amps={[2,3,2,3,2,3,2,4,2,3]}
        />
        <River
          waveCount={5}
          waveColors={['blue', 'lightblue',]}
          waveSpeeds={[0.002, 0.003, 0.005, 0.001, 0.008]}
          documentBackgroundColor='darkblue'
          fillColor='white'
          barColor='rgba(255,255,255,0.5)'
          amps={[2,3,2,3,2,]}
          texts={texts[0]}
          counterIncrement={-0.002}
        />
        <River
          waveCount={10}
          waveColors={['white']}
          waveSpeeds={[0.002, 0.003, 0.005, 0.001, 0.008]}
          documentBackgroundColor='green'
          fillColor='white'
          barColor='rgba(255,255,255,0.5)'
          amps={[10,3,1,3,2]}
          texts={texts[1]}
          bias={(x) => {
            const randomBool = Math.random() > 0.5;
            return randomBool ? x : x - 10;
          }}
        />
        <River
          waveCount={2}
          waveColors={['lightgreen']}
          waveSpeeds={[0.002, 0.003, 0.005, 0.001, 0.008]}
          documentBackgroundColor='black'
          fillColor='white'
          barColor='rgba(255,255,255,0.5)'
          amps={[2,3,2,3,2]}
          texts={texts[2]}
          counterIncrement={-0.1}
        />
        {/* <River
          waveCount={6}
          waveColors={['black']}
          waveSpeeds={[0.002, 0.003, 0.005, 0.001, 0.008]}
          amps={[5,5,5,5,5,5]}
        /> */}
      </div>
    );
  };
  export default RiverCanvas;